// src/Pages/TermosCupons.js
import React from 'react';
import Layout from '../Components/Layout/Layout';

function TermosCupons() {
  return (
    <Layout>
      <div className='page'>
        <h1>Termos de Uso dos Cupons</h1>
        <p>Última atualização: [data]</p>

        <h2>1. Aceitação dos Termos</h2>
        <p>
          Ao utilizar os cupons promocionais da Pizza Prime, você concorda em cumprir estes Termos de Uso.
        </p>

        <h2>2. Validade dos Cupons</h2>
        <p>
          Os cupons têm validade específica, que será informada no momento da oferta. Após a data de validade, o cupom não poderá ser utilizado.
        </p>

        <h2>3. Aplicação dos Cupons</h2>
        <p>
          Os cupons podem ser aplicados apenas nas compras realizadas através do site pizzaprime.com.br, exceto quando indicado de outra forma.
        </p>

        <h2>4. Limites de Uso</h2>
        <p>
          Cada cupom pode ter restrições quanto ao número de utilizações, sendo permitido o uso apenas uma vez por cliente, a menos que especificado de outra forma.
        </p>

        <h2>5. Não Acúmulo</h2>
        <p>
          Os cupons não são cumulativos com outras promoções ou descontos, a menos que indicado expressamente.
        </p>

        <h2>6. Cancelamento e Alterações</h2>
        <p>
          A Pizza Prime reserva-se o direito de cancelar ou alterar os cupons a qualquer momento, sem aviso prévio.
        </p>

        <h2>7. Contato</h2>
        <p>
          Se você tiver dúvidas sobre os Termos de Uso dos Cupons, entre em contato conosco pelo e-mail: contato@pizzaprime.com.br.
        </p>
      </div>
    </Layout>
  );
}

export default TermosCupons;
